export const emailValidation = (value) => {
	const errors = [];
	const validEmail = /^\S+@\S+\.\S+$/;
	if (!value.match(validEmail)) {
		errors.push(['Invalid Email Address']);
	}
	return errors;
};
